import React from "react";
import "./AnimatedCloud.css";

function AnimatedCloud() {
  return (
    <div className="animated-cloud-container">
      {/* Background glow */}
      <div className="cloud-glow" />

      {/* Orbit rings */}
      <div className="cloud-orbit cloud-orbit-1" />
      <div className="cloud-orbit cloud-orbit-2" />

      {/* Network connection lines */}
      <svg className="cloud-connections" viewBox="0 0 500 400" fill="none">
        <line className="conn-line" x1="110" y1="60" x2="250" y2="100" />
        <line className="conn-line conn-line-2" x1="250" y1="100" x2="390" y2="70" />
        <line className="conn-line conn-line-3" x1="130" y1="180" x2="370" y2="150" />
        <line className="conn-line conn-line-4" x1="80" y1="260" x2="420" y2="240" />
        <line className="conn-line conn-line-5" x1="200" y1="50" x2="200" y2="180" />
        <line className="conn-line conn-line-6" x1="320" y1="80" x2="350" y2="200" />
      </svg>

      {/* Floating particles */}
      <div className="cloud-particles">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className={`particle particle-${i}`} />
        ))}
      </div>

      {/* Main cloud SVG */}
      <svg
        className="cloud-main"
        viewBox="0 0 600 257"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="cloudGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#3d69db" stopOpacity="0.95">
              <animate
                attributeName="stop-color"
                values="#3d69db;#5b82e6;#3d69db"
                dur="4s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="#adcdff" stopOpacity="0.85">
              <animate
                attributeName="stop-color"
                values="#adcdff;#d2e4ff;#adcdff"
                dur="4s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
          <linearGradient
            id="cloudStroke"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#5b82e6" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#adcdff" stopOpacity="0.2" />
          </linearGradient>
        </defs>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 124.807 104.633 C 123.771 99.235 123.229 93.661 123.229 87.96 C 123.229 39.381 162.611 0 211.19 0 C 238.898 0 263.614 12.812 279.737 32.835 C 286.547 25.695 296.153 21.247 306.799 21.247 C 327.451 21.247 344.193 37.988 344.193 58.64 C 344.193 59.362 344.172 60.08 344.132 60.792 C 344.076 61.785 343.981 62.768 343.848 63.739 C 353.364 63.77 361.587 69.288 365.52 77.296 C 377.493 44.589 408.896 21.247 445.751 21.247 C 492.922 21.247 531.161 59.486 531.161 106.657 C 531.161 107.005 531.16 107.352 531.156 107.699 C 550.95 111.121 566.006 128.378 566.006 149.15 C 566.006 156.036 564.352 162.535 561.419 168.272 L 583.003 168.272 C 592.39 168.272 600 175.882 600 185.269 C 600 194.657 592.39 202.266 583.003 202.266 L 474.221 202.266 L 473.072 203.966 L 472.608 204.998 C 472.154 206.007 471.802 207.06 471.559 208.14 L 471.516 208.33 C 471.028 210.495 471.01 212.739 471.461 214.911 C 471.561 215.39 471.683 215.863 471.827 216.328 C 471.948 216.724 472.086 217.114 472.238 217.499 C 472.461 218.06 472.718 218.608 473.006 219.14 L 473.072 219.263 L 474.221 220.963 L 492.918 220.963 C 502.774 220.963 510.765 228.953 510.765 238.81 C 510.765 248.667 502.774 256.657 492.918 256.657 L 171.671 256.657 C 161.815 256.657 153.824 248.667 153.824 238.81 C 153.824 228.953 161.815 220.963 171.671 220.963 L 200.567 220.963 L 201.715 219.263 L 201.782 219.14 C 202.499 217.813 203.019 216.389 203.326 214.911 C 203.778 212.739 203.759 210.495 203.271 208.33 L 203.229 208.14 C 203.139 207.739 203.033 207.342 202.914 206.949 C 202.841 206.713 202.764 206.479 202.682 206.246 C 202.532 205.824 202.364 205.407 202.179 204.998 L 201.715 203.966 L 200.567 202.266 L 16.997 202.266 C 7.61 202.266 0 194.657 0 185.269 C 0 175.882 7.61 168.272 16.997 168.272 L 58.911 168.272 C 56.546 162.506 55.241 156.193 55.241 149.575 C 55.241 122.352 77.31 100.283 104.533 100.283 C 111.76 100.283 118.623 101.839 124.807 104.633 Z"
          fill="url(#cloudGradient)"
          stroke="url(#cloudStroke)"
          strokeWidth="1"
        />
      </svg>
    </div>
  );
}

export default AnimatedCloud;
